import ACHContractDialog from 'features/ACHContract'
import Analytics from 'features/Analytics'
import Announcements from 'features/Announcements'
import Bookings from 'features/Bookings'
import CampaignAnalysis from 'features/CampaignAnalysis'
import CartAbandonmentFlow from 'features/CartAbandonmentFlow'
import ChatBotSettings from 'features/ChatBotSettings'
import Compliance from 'features/Compliance'
import Audience from 'features/CustomCampaigns/Audience'
import EditCustomCampaign from 'features/CustomCampaigns/EditCampaign'
import CustomCampaignsList from 'features/CustomCampaigns/List'
import DailyConversations from 'features/DailyConversations'
import UsageStats from 'features/DashboardUssage'
import Debug from 'features/DebugApp'
import EditCampaign from 'features/EditCampaign'
import EditEmail from 'features/EmailCampaign/EditEmail'
import EmailEditor from 'features/EmailEditor'
import Engagement from 'features/Engagement'
import ExternalAnalytics from 'features/ExternalAnalytics'
import GDSBookings from 'features/GDSBookings'
import Go from 'features/Go'
import EditIndependentContract from 'features/GroupContracts/IndependentContract/Edit'
import GroupContractList from 'features/GroupContracts/List'
import EditMerchantContract from 'features/GroupContracts/MerchantContract/Edit'
import InHouseMessagingPerformance from 'features/Hotel/InHouseMessagingPerformance'
import HotelsByLocation from 'features/HotelsByLocation'
import HotelSetup from 'features/HotelSetup'
import CheckACHStatus from 'features/HotelSetup/CheckACHStatus'
import DirectInvoice from 'features/Invoice/DirectInvoice'
import DynamicInvoice from 'features/Invoice/DynamicInvoice'
import InvoiceForPrint from 'features/Invoice/InvoiceForPrint'
import InvoiceAsPDF from 'features/InvoiceAsPDF'
import InvoicedBookings from 'features/InvoicedBookings'
import LoginWithToken from 'features/LoginWithToken'
import MessageSubscribers from 'features/MessageSubscribers'
import Messaging from 'features/Messaging'
import MonthlyOTAConversions from 'features/MonthlyOTAConversions'
import MonthlyRevenue from 'features/MonthlyRevenue'
import NotificationPreferences from 'features/NotificationPreferences'
import Occupancy from 'features/Occupancy'
import PMSLogin from 'features/PMSLogin'
import { PMSReports } from 'features/PMSReports'
import PublishCampaign from 'features/PublishCampaign'
import RateCodes from 'features/RateCodes'
import RestrictedCallDates from 'features/RetrictedCallDates'
import ROI from 'features/ROI'
import HotelNumberPicker from 'features/SetupTelecom'
import Subscribers from 'features/Subscribers'
import SubscriptionAnalytics from 'features/SubscriptionAnalytics'
import SwitchToHotelAndGoToPath from 'features/SwitchToHotelAndGoToPath'
import { userRoleLevels, userRoles } from 'features/UserPermissions'
import Users from 'features/Users'
import Widgets from 'features/Widgets'
import useResortNearDisney from 'hooks/useResortNearDisney'
import { useSelector } from 'react-redux'
import { Redirect, Route, Switch, withRouter } from 'react-router-dom'

import { selectCurrentHotelId } from '../accessors'
import Acquisition from '../features/Acquisition'
import AddGuestData from '../features/AddGuestData'
import AnalyzeResults from '../features/AnalyzeResults'
import Arrivals from '../features/Arrivals'
import Billing from '../features/Billing'
import MakePayment from '../features/Billing/MakePayment'
import BillingManagement from '../features/BillingManagement'
import BookingHistory from '../features/BookingHistory'
import ChatBotTraining from '../features/ChatBotTraining'
import EditHotel from '../features/EditHotel'
import EmailLogs from '../features/EmailLogs'
import GuestDetails from '../features/GuestDetails'
import HealthCheckAutoInvite from '../features/HealthCheck/AutoInvite'
import HealthCheckBilling from '../features/HealthCheck/Billing'
import HealthCheckPerformance from '../features/HealthCheck/Performance'
import HealthCheckPMS from '../features/HealthCheck/PMS'
import HealthCheckSummary from '../features/HealthCheck/Summary'
import { HotelWrapper } from '../features/Hotel'
import Hotels from '../features/Hotels'
import LLMPlatform from '../features/LLMPlatform'
import HotelsByCsm from '../features/HotelsByCsm'
import Insights from '../features/Insights'
import Invoices from '../features/Invoice'
import Login from '../features/Login'
import MagicLink from '../features/MagicLink'
import ManageCampaigns from '../features/ManageCampaigns'
import NewHotel from '../features/NewHotel'
import Onboarding from '../features/Onboarding'
import OperaSetup from '../features/Onboarding/OperaForm'
import Reviews from '../features/Reviews'
import ReviewDetails from '../features/Reviews/ReviewDetails'
import UserPermissions from '../features/UserPermissions'
import Welcome from '../features/Welcome'
import EnsureLoggedInContainer from '../main/EnsureLoggedInContainer'
import GA from './GA'
import PaymentLink from './paymentLink/PaymentLink'
import { LatestVersionLink } from './ReusableComponents/LatestVersionLink'
import VideoTutorial from './ReusableComponents/VideoTutorial'

const Routes = () => {
  const currentHotelId = useSelector(selectCurrentHotelId)
  const roles = useSelector(s => s.login.roles)
  const isInternalAdmin = useSelector(s => s.login.isInternalAdmin)
  const isPreOnboardingCompleted = useSelector(
    s => s.hotelDetails.isPreOnboardingCompleted
  )

  const isResortNearDisney = useResortNearDisney()

  let homeRoute = '/analytics'

  const positivePermissions = [
    userRoleLevels.HasGroupLevelPermission,
    userRoleLevels.HasPermission
  ]

  if (!isPreOnboardingCompleted && !isInternalAdmin) {
    homeRoute = '/hotel-setup'
  } else if (roles) {
    if (positivePermissions.includes(roles[userRoles.Analytics])) {
      homeRoute = '/analytics'
    } else if (positivePermissions.includes(roles[userRoles.ChatInProperty])) {
      homeRoute = '/arrivals'
    } else if (positivePermissions.includes(roles[userRoles.ChatSalesBefore])) {
      homeRoute = '/incoming'
    } else if (positivePermissions.includes(roles[userRoles.ChatSalesAfter])) {
      homeRoute = '/reviews'
    } else if (positivePermissions.includes(roles[userRoles.Billing])) {
      homeRoute = '/billing'
    }
  }

  return (
    <Switch>
      <Route
        exact
        path="/desktop-app"
        render={() => <LatestVersionLink shouldRedirect={true} />}
      />
      <Route path="/directInvoice" component={DirectInvoice} />
      {isInternalAdmin && <Route path="/dynamic-invoice" component={DynamicInvoice} />}
      <Route path="/invoice-for-print" component={InvoiceForPrint} />
      <Route exact path="/magic-link/:id" render={props => <MagicLink {...props} />} />
      <Route path="/s/:subsidiaryId/:path" component={SwitchToHotelAndGoToPath} />
      <Route path="/go/:path" component={Go} />
      <Route exact path="/invite/:token" component={LoginWithToken} />
      <Route path="/login/:status?" component={Login} />
      <Route
        render={props => (
          <div>
            <EnsureLoggedInContainer {...props}>
              <Switch>
                <Route path="/selectHotel" component={Welcome} />
                {!isPreOnboardingCompleted && (
                  <Route path="/ach-contract" component={ACHContractDialog} />
                )}
                {!isPreOnboardingCompleted && (
                  <Route
                    exact
                    path="/hotel-setup/ach-contract-signed"
                    component={CheckACHStatus}
                  />
                )}
                {!isPreOnboardingCompleted && (
                  <Route
                    path="/hotel-setup/:type?/:paymentType?"
                    component={HotelSetup}
                  />
                )}
                {/* {!isInternalAdmin && !isPreOnboardingCompleted && (
                  <Redirect push to="/hotel-setup" />
                )} */}
                <Route path="/email-editor/:id" component={EmailEditor} />
                <Route path="/paymentLink" component={PaymentLink} />
                <Route path="/userPermissions" exact component={UserPermissions} />
                <Route path="/userPermissions/invoice-controls">
                  <UserPermissions showInvoiceControls />
                </Route>
                <Route path="/selectHotel" component={Welcome} />
                <Route path="/addGuestData" component={AddGuestData} />
                <Route path="/manageCampaigns/:type" component={ManageCampaigns} />
                <Route path="/defaultCampaigns/:type">
                  <ManageCampaigns isDefaultCampaigns />
                </Route>
                <Route path="/editCampaign/:type/:category">
                  <EditCampaign />
                </Route>
                <Route path="/editDefaultCampaign/:type/:category">
                  <EditCampaign isDefaultCampaigns />
                </Route>
                <Route path="/publish-campaign/:category">
                  <PublishCampaign />
                </Route>
                <Route
                  path="/guestDetails/:id"
                  render={props => <GuestDetails guestId={props.match.params.id} />}
                />
                <Route path="/acquisition" component={Acquisition} />
                <Route path="/engagement" component={Engagement} />
                <Route path="/addTelecom/:id" component={HotelNumberPicker} />
                <Route path="/onboarding" component={Onboarding} />
                <Route path="/operaSetup" component={OperaSetup} />
                <Route path="/reviews/:date?" component={Reviews} />
                <Route path="/reviewDetails/:date?" component={ReviewDetails} />
                <Route path="/invoice-preview/:ids?/:shallPrint?" component={Invoices} />
                <Route path="/statement/:ids?/:shallPrint?" component={Invoices} />
                <Route path="/invoice/:ids?/:shallPrint?" component={InvoiceAsPDF} />
                <Route path="/transaction" component={MakePayment} />
                <Route path="/message-subscribers" component={MessageSubscribers} />
                <Route
                  path="/contracts/edit/m/:merchantId"
                  component={EditMerchantContract}
                />
                <Route
                  path="/contracts/edit/s/:subsidiaryId"
                  component={EditIndependentContract}
                />
                <Route path="/contracts/new/s" component={EditIndependentContract} />
                <Route path="/contracts" component={GroupContractList} />
                <Route path="/initial/:type/:paymentType" component={MakePayment} exact />
                <Route path="/billing/:type/:paymentType" component={MakePayment} />
                <Route path="/billing/:editBillingInfo?" component={Billing} />
                <Route
                  path="/bookingHistory/:id/:beforeDate?"
                  render={props => (
                    <BookingHistory
                      guestId={props.match.params.id}
                      beforeDate={props.match.params.beforeDate}
                    />
                  )}
                />
                <Route path="/onBoarding" component={Onboarding} />
                <Route path="/hotels" component={Hotels} />
                <Route path="/hotels-by-csm" component={HotelsByCsm} />
                <Route path="/hotels-by-location" component={HotelsByLocation} />
                <Route path="/ga" component={GA} />
                <Route
                  path="/messaging/:chatId?"
                  render={() => (
                    <Messaging messagingType="service" title="In-property messaging" />
                  )}
                />
                <Route
                  path="/incoming/:chatId?/bookings/:subscriberId"
                  render={() => (
                    <Messaging
                      messagingType="sales"
                      title="Before-stay messaging"
                      showBookings={true}
                    />
                  )}
                />
                <Route
                  path="/incoming/:chatId?"
                  render={() => (
                    <Messaging messagingType="sales" title="Before-stay messaging" />
                  )}
                />
                <Route
                  path="/feedback/:chatId?"
                  render={() => (
                    <Messaging messagingType="review" title="Review messaging" />
                  )}
                />
                <Route
                  path="/direct/:chatId?"
                  render={() => (
                    <Messaging messagingType="direct" title="Direct messages" />
                  )}
                />
                <Route
                  path="/hotelDetails/:manageEmails?"
                  render={() => <HotelWrapper id={currentHotelId} />}
                />
                <Route
                  path="/hotel/:id"
                  render={props => <HotelWrapper id={props.match.params.id} />}
                />
                <Route
                  path="/manageBilling/:hotelId/:invoiceId"
                  component={BillingManagement}
                />
                <Route path="/arrivals" component={Arrivals} />
                <Route path="/tutorial" component={VideoTutorial} />
                <Route path="/newHotel" component={NewHotel} />
                <Route path="/editHotel/:id/:limited?" component={EditHotel} />
                <Route path="/insights" component={Insights} />
                <Route path="/analyzeResults" component={AnalyzeResults} />
                <Route path="/aiTraining/:chatId?" component={ChatBotTraining} />
                <Route path="/aiTraining/:chatId?" component={ChatBotTraining} />
                <Route
                  path="/notificationPreferences/:groupType?"
                  component={NotificationPreferences}
                />
                <Route path="/pms-reports" component={PMSReports} />
                <Route path="/healthCheck/autoinvite" component={HealthCheckAutoInvite} />
                <Route path="/healthCheck/billing" component={HealthCheckBilling} />
                <Route path="/healthCheck/pms" component={HealthCheckPMS} />
                <Route
                  path="/healthCheck/performance"
                  component={HealthCheckPerformance}
                />
                <Route path="/healthCheck/summary" component={HealthCheckSummary} />
                <Route path="/llm-platform" component={LLMPlatform} />
                <Route path="/emails/:type" component={EmailLogs} />
                {/* <Route path="/downloadApp" component={DownloadApp} /> */}
                <Route path="/users" component={Users} />
                <Route path="/edit-email" component={EditEmail} />
                <Route path="/bookings" component={Bookings} />
                <Route path="/gds-bookings" component={GDSBookings} />
                <Route path="/debugApp" component={Debug} />
                <Route path="/dailyConversations" component={DailyConversations} />
                <Route path="/subscription-analytics" component={SubscriptionAnalytics} />
                {isResortNearDisney ? (
                  <Route path="/analytics" component={ExternalAnalytics} />
                ) : (
                  <Route path="/analytics" component={Analytics} />
                )}
                <Route path="/subscribers/" component={Subscribers} />
                <Route path="/site-abandonment" component={Widgets} exact />
                <Route
                  exact
                  path="/custom-campaigns/:newParam(new-campaign|new-audience)?"
                  component={CustomCampaignsList}
                />
                <Route
                  path="/custom-campaigns/:id/:isNew?"
                  component={EditCustomCampaign}
                />
                <Route path="/custom-audience/:id" component={Audience} />
                <Route path="/announcements/:audience?" component={Announcements} />
                <Route path="/roi" exact component={ROI} />
                <Route
                  path="/messaging-performance"
                  component={InHouseMessagingPerformance}
                />
                <Route path="/pms" component={PMSLogin} />
                <Route path="/pms-login" component={PMSLogin} />
                <Route path="/occupancy" component={Occupancy} />
                <Route path="/rate-codes" component={RateCodes} />
                <Route path="/chatbot-responses" component={ChatBotSettings} />
                <Route path="/restricted-call-dates" component={RestrictedCallDates} />
                <Route path="/campaign-analysis" component={CampaignAnalysis} />
                <Route path="/compliance" component={Compliance} />
                <Route
                  path="/monthly-ota-conversions"
                  component={MonthlyOTAConversions}
                />
                <Route path="/monthly-revenue" component={MonthlyRevenue} />
                <Route
                  path="/roi/invoiced-bookings/:invoiceId/:date"
                  render={props => <InvoicedBookings prevPage="roi" {...props} />}
                />
                <Route path="/usage-stats" component={UsageStats} />
                <Route path="/external-analytics" component={ExternalAnalytics} />
                <Route
                  path="/crash"
                  render={() => {
                    throw new Error('intentional error')
                  }}
                />
                <Redirect from="/emails" to="/emails/invoice" />
                <Redirect from="/invoices" to="/billing" />
                <Redirect from="/healthCheck" to="/healthCheck/pms" />
                <Route
                  path="/site-abandonment/campaign-flow"
                  component={CartAbandonmentFlow}
                />
                <Redirect from="/" to={homeRoute} />
                <Route render={() => <Redirect to={{ pathname: '/' }} />} />
              </Switch>
            </EnsureLoggedInContainer>
          </div>
        )}
      />
    </Switch>
  )
}

export default withRouter(Routes)
